import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Dialog, withStyles } from "@material-ui/core";
import * as actions from './store/deviceCasePreselectionActions';
import * as adminDiagnoseCaseActions from '../AdminDiagnoseCase/store/adminDiagnoseCaseActions';
import * as customerDiagnoseCaseActions from '../../sc-settings/CustomerDiagnoseCase/store/customerDiagnoseCaseActions';
import AppLogoLoading from "../../sc-logo";
import DeviceCasePreselectionForm from "./DeviceCasePreselectionForm";
import { checkIfLoading, hasPermission, parseURL } from "../../sc-utilities";
import * as Yup from "yup";
import History from "../../../History";

const styles = (theme) => ({
    loadingScreen: {
        backgroundColor: "transparent",
        boxShadow: "none",
    },
});

const DeviceCasePreselectionDetails = (props) => {
    const { classes, onFetchDeviceModels, activeCustomerID, onFetchAdminDiagnoseCases, onFetchCustomerDiagnoseCases,  translations, permissions, onFetchDeviceCasePreselection, onEditDeviceCasePreselection, onCreateDeviceCasePreselection } = props;

    const searchParams = parseURL(window.location.href);
    const [deviceCasePreselection, setDeviceCasePreselection] = useState(null);

    const [loading, setLoading] = useState({ deviceCase: false });
    const isEdit = window.location.href.includes("update");

    const getDeviceCase = async () => {
        setLoading(prevState => { return { ...prevState, deviceCase: true } });
        const result = await onFetchDeviceCasePreselection({ DeviceCasePreselectionID: searchParams?.deviceCasePreselectionID, ActiveCustomerID: activeCustomerID });
        if (result) {
            setDeviceCasePreselection(result);
        }
        setLoading(prevState => { return { ...prevState, deviceCase: false } });
    };

    useEffect(() => {
        if (isEdit) {
            getDeviceCase();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isAdminView = window.location.href.includes('/admin');

    const handleCreate = async (data) => {
        const DiagnoseCaseIDs = data.DiagnoseCases.map((option) => option.DiagnoseCaseID);
        const DeviceModelIDs = data.DeviceModels.map((option) => option.value);
        const createParams = { ClientType: data.ClientType, DiagnoseCaseIDs: DiagnoseCaseIDs, DeviceModelIDs: DeviceModelIDs, Name: data.Name, ActiveCustomerID: activeCustomerID };
        
        if (isAdminView && hasPermission(permissions, 'system_device_case_preselection_create')) {
            createParams['CustomerID'] = null;
        }
        await onCreateDeviceCasePreselection(createParams);
        History.goBack();

    }
    const handleEdit = async (data) => {
        const DiagnoseCaseIDs = data.DiagnoseCases.map((option) => option.DiagnoseCaseID);
        const DeviceModelIDs = data.DeviceModels.map((option) => option.value);
        await onEditDeviceCasePreselection({ DeviceCasePreselectionID: searchParams?.deviceCasePreselectionID, ClientType: data.ClientType, DiagnoseCaseIDs: DiagnoseCaseIDs, DeviceModelIDs: DeviceModelIDs, Name: data.Name, ActiveCustomerID: activeCustomerID });
        History.goBack();
    }

    const initialValues = {
        Name: deviceCasePreselection?.Name || "",
        ClientType: deviceCasePreselection?.ClientType || "work",
        DiagnoseCases: deviceCasePreselection?.DeviceCasePreselectionDiagnoseCases?.map(diagnoseCase => { return { DiagnoseCaseID: diagnoseCase.DiagnoseCaseID, OriginalLongName: diagnoseCase.LongName } }) || [],
        DeviceModels: deviceCasePreselection?.DeviceCasePreselectionDeviceModels?.map(deviceModel => { return { value: deviceModel.DeviceModelID, displayValue: `${deviceModel.Vendor} - ${deviceModel.Model}` } }) || []
    }

    const formSettings = {
        Validation: {
            Name: Yup.string().required(),
            DiagnoseCases: Yup.string(),
            ClientType: Yup.string().required(),
        },
        FormTitle: isEdit ? translations["device_case_preselection_details"] || "Device case preselection details" : translations['create_device_case_preselection'] || 'Create device case preselection',
        ButtonSubmit: hasPermission(permissions, isEdit ? (isAdminView || deviceCasePreselection?.CustomerID === null ? 'system_device_case_preselection_update' : 'device_case_preselection_update') : (isAdminView ? 'system_device_case_preselection_create' : 'device_case_preselection_create' )) && {
            Title: translations["save"] || "SAVE"
        }
    }
    const loadingScreen = <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={checkIfLoading(loading)} PaperProps={{ classes: { root: classes.loadingScreen } }}>
        <AppLogoLoading />
    </Dialog>

    return <>
        {checkIfLoading(loading) ? loadingScreen : <DeviceCasePreselectionForm onFetchDiagnoseCases={isAdminView ? onFetchAdminDiagnoseCases : onFetchCustomerDiagnoseCases} /*onFetchDeviceModels={onFetchDeviceModels} */activeCustomerID={activeCustomerID} permissions={permissions} formSettings={formSettings} initialValues={initialValues} handleSubmit={isEdit ? handleEdit : handleCreate} translations={translations} isEdit={isEdit} />}
    </>
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onFetchDeviceCasePreselection: params => dispatch(actions.fetchDeviceCasePreselection(params)),
        onEditDeviceCasePreselection: data => dispatch(actions.editDeviceCasePreselection(data)),
        onCreateDeviceCasePreselection: data => dispatch(actions.createDeviceCasePreselection(data)),
        onFetchCustomerDiagnoseCases: filter => dispatch(customerDiagnoseCaseActions.fetchCustomerDiagnoseCases(filter)),
        onFetchAdminDiagnoseCases: filter => dispatch(adminDiagnoseCaseActions.fetchAdminDiagnoseCases(filter)),
        // onFetchDeviceModels: params => dispatch(actions.fetchDeviceModels(params))
    };
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(DeviceCasePreselectionDetails));
